import { useLocation, useNavigate } from '@tanstack/react-router';
import type { Key } from 'react';

import { FilterList, FilterListItem, useMediaQuery } from '@/libs/serenity-ui';
import { breakpoints } from '@/libs/serenity-ui/constants.stylex';
import { Route } from '@/routes/_main/_list';
import type { ColumnFilter, FilterListAdapterResult } from '@/utils/define-filter-list-adapter.util';

interface ActiveFiltersProps {
  searchFilterId: string;
  filterListAdapter: (columnFilter: ColumnFilter[]) => FilterListAdapterResult;
}

export function ActiveFilters(props: ActiveFiltersProps) {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const location = useLocation();

  const isSmallScreen = useMediaQuery(breakpoints.small);

  const filterResult = props.filterListAdapter(search.columnFilters.filter((f) => f.id !== props.searchFilterId));

  const handleRemove = (keys: Set<Key>) => {
    if (!filterResult) {
      return;
    }

    navigate({
      to: location.pathname,
      search: {
        ...search,
        columnFilters: filterResult.remove(Array.from(keys).map(String), search.columnFilters),
        pagination: { ...search.pagination, pageIndex: 0 },
      },
    });
  };

  return !isSmallScreen && filterResult.items.length > 0 &&
    <FilterList items={filterResult.items} onRemove={handleRemove}>
      {(item) => <FilterListItem category={item.category} id={item.id} isPending={item.isPending} textValue={item.value}>{item.value}</FilterListItem>}
    </FilterList>;
}
